import { Navigate } from "react-router-dom";

export default function ConsultantProfile() {
  return <Navigate to="/consultant/profile/setup" replace />;
}
